import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPMachineryDetailsTableDataAPI = createAsyncThunk("STPMachineryDetailsTableData", async ({ data }) => {
    const {
        M_WardID,
        M_STP_MachEquipmentTypeID,
        M_STP_MachineryDetailsID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_STP_MachineryDetails_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_MachEquipmentTypeID=${M_STP_MachEquipmentTypeID ? M_STP_MachEquipmentTypeID : '0'}&M_STP_MachineryDetailsID=${M_STP_MachineryDetailsID ? M_STP_MachineryDetailsID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPMachineryDetailsTableDataSlice = createSlice({
    name: "STPMachineryDetailsTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryDetailsTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPMachineryDetailsTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPMachineryDetailsTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryDetailsTableDataReducer = STPMachineryDetailsTableDataSlice.reducer


export const STPMachineryDetailsPostDataAPI = createAsyncThunk("STPMachineryDetailsPostData", async ({ data }) => {
    const {
        M_STP_MachineryDetailsID,
        M_WardID,
        M_STP_MachEquipmentTypeID,
        MachineryDetails,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_STP_MachineryDetailsID", M_STP_MachineryDetailsID);
    formdata.append("M_WardID", M_WardID);
    formdata.append("M_STP_MachEquipmentTypeID", M_STP_MachEquipmentTypeID);
    formdata.append("MachineryDetails", MachineryDetails);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_STP_MachineryDetails_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPMachineryDetailsPostDataSlice = createSlice({
    name: "STPMachineryDetailsPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryDetailsPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPMachineryDetailsPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPMachineryDetailsPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryDetailsPostDataReducer = STPMachineryDetailsPostDataSlice.reducer

// -----------------Delete API ---------------

export const STPMachineryDetailsDeleteAPI = createAsyncThunk("STPMachineryDetailsDelete", async ({ data }) => {
    const {
        M_STP_MachineryDetailsID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_STP_MachineryDetailsID", M_STP_MachineryDetailsID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/master/WEB_M_STP_MachineryDetails_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPMachineryDetailsDeleteSlice = createSlice({
    name: "STPMachineryDetailsDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryDetailsDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPMachineryDetailsDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPMachineryDetailsDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryDetailsDeleteReducer = STPMachineryDetailsDeleteSlice.reducer